/** Composes a CSS color from the hex + opacity percentage pair settings store. */
export function hexToRgba(
  hexColor: string | null | undefined,
  opacityPercent: number | null | undefined
): string {
  const alpha = Math.min(Math.max(opacityPercent ?? 100, 0), 100) / 100;

  if (!hexColor) return `rgba(0, 0, 0, ${alpha})`;

  const hex = hexColor.replace('#', '');
  const isShort = hex.length === 3;

  const r = parseInt(isShort ? hex[0] + hex[0] : hex.slice(0, 2), 16);
  const g = parseInt(isShort ? hex[1] + hex[1] : hex.slice(2, 4), 16);
  const b = parseInt(isShort ? hex[2] + hex[2] : hex.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
